import { Component, ElementRef, ViewChild } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment.development';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types';

@Component({
  selector: 'app-topselling-product',
  templateUrl: './topselling-product.component.html',
  styleUrl: './topselling-product.component.scss',
})
export class TopsellingProductComponent {
  @ViewChild('swiperContainer', { static: false }) swiperContainer!: ElementRef;
  public swiper!: Swiper;
  subCategoriesProduct: any;
  catProductimgUrl = environment.ImageBaseUrl;
  History: any[];
  banner: any;
  fetchDiscountedFurniture: any;
  recentProducts: any[];
  isAtEnd: boolean = false;
  isSuggestedAtEnd: boolean = false;
  private scrollCheckScheduled = false;
  private suggestedScrollCheckScheduled = false;
  constructor(
    private api: ApiServiceService,
    private router: Router,
  ) {}
  // ngOnInit() {
  //   this.getAllCategories().then(() => {
  //     this.initializeSwiper();
  //   });
  // }

  products: any[] = [];

  ngOnInit() {
    this.getAllCategories();
    this.popularProducts();
    this.loadSearchHistoryProducts();
    this.getBanners();
    this.fetchDiscountedElectroni();
    this.loadBrowsingHistory();
  }

  ngAfterViewInit() {
    this.initializeSwiper();
  }
  initializeSwiper() {
    const swiperEl = this.swiperContainer?.nativeElement as any;
    if (!swiperEl) {
      return;
    }
    Object.assign(swiperEl, {
      slidesPerView: 6,
      spaceBetween: 30,
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 6,
        },
      },
    });
    swiperEl.initialize();
  }

  // getAllCategories() {
  //   return new Promise((resolve, reject) => {
  //     this.api.getAllCategories().subscribe((data: any) => {
  //       this.subCategoriesProduct = data.categories;
  //       resolve(data.categories);
  //     });
  //   });
  // }
  getAllCategories() {
    this.api.getAllCategories().subscribe((data: any) => {
      this.subCategoriesProduct = data.categories;
      // console.log('subCategoriesProduct---->' ,this.subCategoriesProduct)
    });
  }

  topSellingProduct(id: any) {
    this.router.navigate(['product-list', id]);
  }

  popularProducts() {
    this.api.popularProdut().subscribe((data: any) => {
      this.products = data.data;
      console.log('products popular---->', this.products);
    });
  }

  getProductById(id: any) {
    this.router.navigate(['product-details', id]);
  }

  getBanners() {
    this.api.getBanners().subscribe((response: any) => {
      if (Array.isArray(response.data) && response.data.length > 0) {
        this.banner = response.data[22]; // only 1 banne
        console.log('this-banner', response);
      }
    });
  }

  fetchDiscountedElectroni() {
    this.api.getDiscountedOnFurnitureProducts().subscribe({
      next: (products: any) => {
        this.fetchDiscountedFurniture = products;
        console.log(
          'fetchDiscountedFurniture-->',
          this.fetchDiscountedFurniture,
        );
      },
    });
  }

  furntureProductList() {
    this.router.navigate(['product-list'], {
      state: this.fetchDiscountedFurniture,
    });
  }

  loadSearchHistoryProducts() {
    const ids: string[] = JSON.parse(
      localStorage.getItem('searchedProducts') || '[]',
    );

    console.log('IDs sent to API --->', ids);

    if (!ids.length) return;

    this.api.getProductsByIds(ids).subscribe({
      next: (products) => {
        this.History = products;
        console.log('Products received --->', this.History);
      },
      error: (err) => {
        console.error('API error', err);
      },
    });
  }
  loadBrowsingHistory() {
    const ids: string[] = JSON.parse(
      localStorage.getItem('browseProducts') || '[]',
    );

    console.log('IDs sent to API --->', ids);

    if (!ids.length) return;

    this.api.getProductsByIds(ids).subscribe({
      next: (products) => {
        this.recentProducts = products;
        console.log('recentProducts --->', this.History);
      },
      error: (err) => {
        console.error('API error', err);
      },
    });
  }
  browserAllHistory() {
    this.router.navigate(['product-list'], { state: this.recentProducts });
  }
  onScroll(event: Event) {
    if (this.scrollCheckScheduled) return;

    this.scrollCheckScheduled = true;
    const element = event.target as HTMLElement;
    requestAnimationFrame(() => {
      const atEnd =
        element.scrollWidth - element.scrollLeft <= element.clientWidth + 5;
      this.isAtEnd = atEnd;
      this.scrollCheckScheduled = false;
    });
  }
  onSuggestedScroll(event: Event) {
    if (this.suggestedScrollCheckScheduled) return;

    this.suggestedScrollCheckScheduled = true;
    const element = event.target as HTMLElement;
    requestAnimationFrame(() => {
      const reachedEnd =
        element.scrollWidth - element.scrollLeft <= element.clientWidth + 10;
      this.isSuggestedAtEnd = reachedEnd;
      this.suggestedScrollCheckScheduled = false;
    });
  }
}
